module.exports = __webpack_public_path__ + "img/software-development.7c273e92.svg";